import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-gw3-web-guid',
  template: `
    <p>
      gw3-web-guid works!
    </p>
  `,
  styles: []
})
export class Gw3WebGuidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
